/* Veda v36: product-card quick add (choose colour -> choose size -> Add to cart)
   and a gentle 6-second delay before any email sign-up popup appears. */
(function () {
  if (window.__vedaCards) return; window.__vedaCards = true;

  function variants(qa) {
    if (!qa.__v) { try { qa.__v = JSON.parse((qa.querySelector('[data-v-qa-variants]') || {}).textContent || '[]'); } catch (e) { qa.__v = []; } }
    return qa.__v;
  }
  function state(qa) {
    var on = qa.querySelector('.v-sw__dot.is-on');
    var sz = qa.querySelector('.v-sz__btn.is-sel');
    return { color: on ? on.dataset.color : null, size: sz ? sz.dataset.size : null, ci: +qa.dataset.ci, si: +qa.dataset.si };
  }
  function match(qa, st) {
    return variants(qa).filter(function (v) {
      return v.a && (st.si < 0 || v.o[st.si] === st.size) && (st.ci < 0 || !st.color || v.o[st.ci] === st.color);
    })[0];
  }
  function msg(qa, html, cls) {
    var m = qa.querySelector('[data-v-qa-msg]'); if (!m) return;
    m.className = 'v-qa__msg' + (cls ? ' ' + cls : ''); m.innerHTML = html || '';
  }
  function label(qa) {
    var st = state(qa), l = qa.querySelector('[data-v-qa-label]'); if (!l) return;
    l.textContent = st.size ? 'Add to cart · ' + st.size : 'Add to cart';
  }
  function selectSize(btn) {
    var qa = btn.closest('[data-v-qa]'); if (!qa || btn.classList.contains('is-out')) return;
    var was = btn.classList.contains('is-sel');
    qa.querySelectorAll('.v-sz__btn').forEach(function (b) { b.classList.remove('is-sel'); b.setAttribute('aria-pressed', 'false'); });
    if (!was) { btn.classList.add('is-sel'); btn.setAttribute('aria-pressed', 'true'); }
    qa.classList.remove('is-need-size'); msg(qa, ''); label(qa);
  }
  function bagIcon() {
    var sel = ['cart-icon', '.header-actions__cart-icon', '[data-testid="cart-drawer-trigger"]', 'a[href$="/cart"]', 'button[aria-controls*="cart" i]', '.header__icon--cart'];
    for (var i = 0; i < sel.length; i++) {
      var els = document.querySelectorAll(sel[i]);
      for (var j = 0; j < els.length; j++) { var r = els[j].getBoundingClientRect(); if (r.width && r.height && r.top < 200) return els[j]; }
    }
    return null;
  }
  /* Instant add-to-bag motion: the card shrinks right where it is, then glides along a soft arc into the bag */
  function flyCard(btn) {
    return new Promise(function (resolve) {
      var card = btn.closest('.v-card, product-card');
      var src = card && (card.matches('product-card') ? (card.querySelector('.product-card__content') || card) : card);
      if (!src || !src.animate) { resolve(); return; }
      var target = bagIcon();
      var a = src.getBoundingClientRect();
      /* when the header has scrolled away, aim for the top-right corner where the bag sits */
      var b = target ? target.getBoundingClientRect() : null;
      if (!b || b.bottom < 0 || b.top > innerHeight) b = { left: innerWidth - 56, top: 14, width: 32, height: 32 };
      var el = src.cloneNode(true);
      el.querySelectorAll('script, [id]').forEach(function (n) { if (n.tagName === 'SCRIPT') n.remove(); else n.removeAttribute('id'); });
      el.removeAttribute('id'); el.removeAttribute('href'); el.classList.add('v-own');
      root0.classList.add('v-adding'); setTimeout(function () { root0.classList.remove('v-adding'); }, 2500);
      el.style.cssText = 'position:fixed;margin:0;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;z-index:2147483000;pointer-events:none;transform-origin:50% 50%;border-radius:16px;overflow:hidden;background:#fff;box-shadow:0 30px 60px -24px rgb(0 0 0 / .45);will-change:transform,opacity;transition:none';
      document.body.appendChild(el);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var small = 0.3, frames = [{ transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 }, { transform: 'translate(0,-8px) scale(' + small + ')', opacity: 1, borderRadius: '22px', offset: 0.22 }];
      var N = 16, cx = dx * 0.2, cy = Math.min(0, dy) - 120;
      for (var k = 1; k <= N; k++) {
        var t = k / N, e = t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2, u = 1 - e;
        var px = 2 * u * e * cx + e * e * dx, py = -8 * u * u + 2 * u * e * cy + e * e * dy;
        var sc = small - (small - 0.06) * e;
        frames.push({ transform: 'translate(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')', opacity: e > .85 ? Math.max(.1, 1 - (e - .85) * 6) : 1, borderRadius: '40px', offset: 0.22 + 0.78 * t });
      }
      var anim = el.animate(frames, { duration: 700, easing: 'linear', fill: 'forwards' });
      anim.onfinish = function () { el.remove(); resolve(); };
      setTimeout(function () { if (el.isConnected) { el.remove(); resolve(); } }, 1200);
    });
  }
  function add(btn) {
    var qa = btn.closest('[data-v-qa]'); if (!qa || btn.classList.contains('is-busy')) return;
    var st = state(qa);
    if (st.si >= 0 && !st.size) {
      qa.classList.remove('is-need-size'); void qa.offsetWidth; qa.classList.add('is-need-size');
      msg(qa, 'Please choose a size first.', 'is-warn'); return;
    }
    var v = match(qa, st);
    if (!v) { msg(qa, 'That combination is sold out — try another colour or size.', 'is-warn'); return; }
    btn.classList.add('is-busy');
    var flight = flyCard(btn);
    var req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); });
    Promise.all([req, flight])
      .then(function (res) {
        var cart = res[0];
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        msg(qa, 'Added ' + [st.color, st.size].filter(Boolean).join(', ') + ' to your cart. <a href="/cart">View cart</a>');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'veda-card-add', data: { itemCount: cart.item_count, source: 'veda-card-add' } } }));
        document.querySelectorAll('.header-actions__cart-count, cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        pulseBag(); showToast(cart);
      })
      .catch(function () { msg(qa, 'Could not add — please try again.', 'is-warn'); })
      .finally(function () { btn.classList.remove('is-busy'); });
  }

  /* ---- one animation only, and a quiet confirmation instead of the full cart on desktop ---- */
  var root0 = document.documentElement;
  (function () {
    var st = document.createElement('style');
    st.textContent = 'html.v-adding .v-fly:not(.v-own),html.v-adding fly-to-cart{display:none!important}';
    document.head.appendChild(st);
  })();
  function isDesktop() { return window.matchMedia('(min-width: 750px)').matches; }
  function pulseBag() {
    var t = bagIcon(); if (!t) return;
    t.classList.remove('v-bag-pulse'); void t.offsetWidth; t.classList.add('v-bag-pulse');
  }
  var toastTimer;
  function showToast(cart) {
    var it = cart && cart.items && cart.items[0];
    var go = function (c) {
      it = c && c.items && c.items[0]; if (!it) return;
      var old = document.querySelector('.v-toast'); if (old) old.remove();
      var t = document.createElement('div'); t.className = 'v-toast'; t.setAttribute('role', 'status');
      var variant = (it.variant_options || []).filter(function (o) { return !/^(denim\d|dark|light|classic|nude)$/i.test(o); }).join(' · ');
      t.innerHTML = '<img class="v-toast__img" alt="">' +
        '<div><p class="v-toast__k">Added to your bag</p><p class="v-toast__t"></p><p class="v-toast__v"></p>' +
        '<div class="v-toast__a"><a href="/cart">View bag (' + c.item_count + ')</a><a class="is-dark" href="/checkout">Checkout</a></div></div>';
      if (it.image) t.querySelector('img').src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      t.querySelector('.v-toast__t').textContent = it.product_title;
      t.querySelector('.v-toast__v').textContent = variant;
      document.body.appendChild(t);
      requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-in'); }); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 700); }, 4500);
    };
    if (it) go(cart); else fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(go).catch(function () {});
  }
  /* Desktop: never slide the full cart open after adding (from cards or product pages) - show the small note instead, so shoppers keep browsing */
  var justAdded = 0;
  window.addEventListener('cart:update', function () {
    if (!isDesktop()) return;
    justAdded = Date.now();
    document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function (d) { d.removeAttribute('auto-open'); });
  }, true);
  document.addEventListener('cart:update', function () {
    if (!isDesktop()) return;
    justAdded = Date.now();
    document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function (d) { d.removeAttribute('auto-open'); });
  }, true);
  if (window.customElements) customElements.whenDefined('cart-drawer-component').then(function () {
    var C = customElements.get('cart-drawer-component'); if (!C || C.prototype.__vedaPatched) return;
    var orig = C.prototype.open; C.prototype.__vedaPatched = true;
    C.prototype.open = function () {
      if (isDesktop() && justAdded && Date.now() - justAdded < 3000) {
        justAdded = 0;
        if (!document.querySelector('.v-toast')) showToast(null);
        return;
      }
      return orig.apply(this, arguments);
    };
  });
  /* keep the older delayed card animation out of the way: our motion starts on the click itself */
  window.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-v-qa-add], [data-v-qa] .v-sz__btn')) e.stopPropagation(); }, true);
  /* when the colour changes, drop a size that is not available in that colour */
  function recheck(qa) {
    setTimeout(function () {
      var sel = qa.querySelector('.v-sz__btn.is-sel');
      if (sel && sel.classList.contains('is-out')) { sel.classList.remove('is-sel'); sel.setAttribute('aria-pressed', 'false'); label(qa); }
    }, 30);
  }
  /* window capture runs before the older size-tap-adds handler, so a size tap now only selects */
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.v-sz__btn, [data-v-qa-add]');
    if (!t) {
      var d = e.target.closest && e.target.closest('.v-sw__dot');
      if (d) { var q = d.closest('[data-v-qa]'); if (q) recheck(q); }
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    if (t.matches('[data-v-qa-add]')) add(t); else selectSize(t);
  }, true);
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target; if (!t.closest) return;
    if (!t.matches('.v-sz__btn, [data-v-qa-add]')) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    if (t.matches('[data-v-qa-add]')) add(t); else selectSize(t);
  }, true);
  document.addEventListener('mouseover', function (e) {
    var d = e.target.closest && e.target.closest('.v-sw__dot'); if (d) { var q = d.closest('[data-v-qa]'); if (q) recheck(q); }
  });

  /* ——— Email sign-up popups wait 6 seconds after the page loads ——— */
  var root = document.documentElement;
  var start = (window.performance && performance.timing && performance.timing.navigationStart) || Date.now();
  var wait = Math.max(0, 6000 - (Date.now() - start));
  var held = [];
  function isSignup(el) {
    if (!(el instanceof HTMLElement) || el.closest('.v-foot, footer, #header-group, main')) return false;
    if (el.matches('[class*="kl-private-reset-css"], .needsclick, [data-testid="POPUP"], [data-testid="FLYOUT"], [data-testid="FULLSCREEN"], [class*="kl-teaser"]')) return true;
    if (!el.querySelector('input[type="email"], iframe[src*="form" i]')) return false;
    var cs = getComputedStyle(el);
    return cs.position === 'fixed' || el.getAttribute('role') === 'dialog' || el.tagName === 'DIALOG';
  }
  function hold(el) { if (held.indexOf(el) < 0) { held.push(el); el.classList.add('v-pop-hold'); } }
  if (wait > 0 && !root.classList.contains('v-pop-ok')) {
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (list) {
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (!(n instanceof HTMLElement)) return;
            if (isSignup(n)) hold(n);
            else n.querySelectorAll && n.querySelectorAll('[role="dialog"], dialog, [class*="kl-private-reset-css"]').forEach(function (c) { if (isSignup(c)) hold(c); });
          });
        });
      });
      mo.observe(root, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, wait);
    }
    setTimeout(function () {
      root.classList.add('v-pop-ok');
      held.forEach(function (el) { el.classList.remove('v-pop-hold'); });
    }, wait);
  } else {
    root.classList.add('v-pop-ok');
  }
})();
